import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator'
import { AppMenuServiceProxy, AppCardServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import {
  MasterlinkRoleServiceProxy,
  TenantAppServiceProxy, 
  TenantAppVO 
} from '@/service-proxies/app-v2/system.service-proxies'
const amsp = new AppMenuServiceProxy()
const mrsp = new MasterlinkRoleServiceProxy()
const tasp = new TenantAppServiceProxy()
const acsp = new AppCardServiceProxy()

import './index.less'
import { from,  concat, scheduled, asyncScheduler } from 'rxjs'
import { map, reduce, concatAll } from 'rxjs/operators'
import service from '@/utils/request'
import { getUserInfo } from '@/utils/auth'


@Component
class MenuTable extends Vue {
  @Prop({ default: () => [] }) data
  @Prop({ default: false }) loading: boolean

  childMap: { [name: string]: string[] } = {}
  parentMap: { [name: string]: string } = {}
  checkMap: { [name: string]: boolean } = {}
  editionMap: { [name: string]: boolean } = {}

  @Watch('data', { immediate: true })
  gen(val) {
    this.initCheckMap(val)
  }

  initCheckMap(data) {
    const checkMap = {}
    const childMap = {}
    const editionMap = {}
    const parentMap = {}
    const queue = []
    for (let i = 0; i < data.length; i++) {
      queue.push(data[i])
      while (queue.length) {
        const first = queue.shift()
        if (first.children.length) {
          first.children.forEach(item => {
            queue.push(item)
            parentMap[item.id] = first.id
          })
        }
        childMap[first.id] = first.children.map(item => item.id)
        checkMap[first.id] = first.attribute.isAuthed
        editionMap[first.id] = first.attribute.edition
      }
    }
    this.checkMap = checkMap
    this.childMap = childMap
    this.parentMap = parentMap
    this.editionMap = editionMap
  }

  check(id, bool) {
    // 勾选全部子节点
    this.checkMap[id] = bool
    this.childMap[id].forEach(item => {
      this.checkMap[item] = bool
      if (this.childMap[item].length) {
        this.check(item, bool)
      }
    })
    // 勾选自己的父节点
    if (bool) {
      const a = this.parentMap[id]
      this.checkMap[a] = true
      const b = this.parentMap[a]
      if (b) {
        this.checkMap[b] = true
      } else return
      const c = this.parentMap[b]
      if (c) {
        this.checkMap[c] = true
      } else return
      const d = this.parentMap[c]
      if (d) {
        this.checkMap[d] = true
      } else return
      const e = this.parentMap[d]
      if (e) {
        this.checkMap[e] = true
      } else return
    }
  }

  render() {
    const genParentChildren = o => {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'strech',
          }}
        >
          <div
            style={{
              flex: 'none',
              width: '160px',
              padding: '8px',
              borderRight: '1px solid #eee',
            }}
          >
            <a-checkbox
              style={{width: '100%'}}
              id={`cb-${o.id}`}
              checked={this.checkMap[o.id]}
              onChange={e => this.check(o.id, e.target.checked)}
            >
              <ellipsis length={12} tooltip>
              {this.$t(o.key)}
              </ellipsis>
              {o.attribute.edition===4? <a-icon type="wechat" style='font-size: 16px;float:right;margin:-6px -6px 0 0;color: #2aae67;' /> : ''}
            </a-checkbox>
          </div>
          {o.children.length > 0 ? genBtnsAndPages(o.children) : null}
        </div>
      )
    }
    const genBtnsAndPages = arr => {
      const btns = arr.filter(item => {
        return item.attribute.category === 2
      })

      const pages = arr.filter(item => {
        return item.attribute.category === 1
      })

      return (
        <div>
          {btns.length > 0 ? (
            <div
              style={{
                borderBottom: pages.length > 0 ? '1px solid #eee' : 'none',
              }}
            >
              {btns.map(item => {
                return (
                  <div style="width: 160px; display: inline-block; padding: 8px">
                    
                    <a-checkbox style="width: 100%" checked={this.checkMap[item.id]} onChange={e => this.check(item.id, e.target.checked)}>
                      <ellipsis length={16} tooltip>
                        {this.$t(item.key)}
                      </ellipsis>
                      {item.attribute.edition===4? <a-icon type="wechat" style='font-size: 16px;float:right;margin:-6px -6px 0 0;color: #2aae67;' /> : ''}
                    </a-checkbox>
                  </div>
                )
              })}
            </div>
          ) : null}

          {pages.map((item, index) => {
            if (index !== pages.length - 1) {
              return <div style="border-bottom: 1px solid #eee">{genParentChildren(item)}</div>
            } else {
              return <div>{genParentChildren(item)}</div>
            }
          })}
        </div>
      )
    }
    const comp = this.data.map(item => {
      const temp = genParentChildren(item)
      return <div style="border-bottom: 1px solid #eee">{temp}</div>
    })

    return (
      <a-spin spinning={this.loading} style="width: 100%;">
        <div style="border: 1px solid #eee; border-bottom: none; margin-bottom: 16px; width: 100%; overflow-x: auto">
          {comp}
        </div>
      </a-spin>
    )
  }
}

@Component
export default class RolePermission extends Vue {
  @Ref() menuTable: MenuTable
  @Prop() roleId: string

  appData: TenantAppVO[] = []
  currentApp: string = ''
  permissionData = []
  loading = {
    table: false,
    save: false,
    dataPermission: false,
    cardPermission: false,
  }
  currentEdition: number = 0
  currentPanel = null
  dataPermissionTree = {
    checkedKeys: [],
    treeData: [],
    saveBody: null,
  }
  cardPermissionTree: {
    [name: string]: {
      treeData: [{ title: string; key: string }]
      checkedKeys: string[]
    }
  } = {}
  currentCardApp = ''
  isLoadingPermissionData = false

  @Watch('roleId')
  updatePermissions(val) {
    if (!val) return
    if (!this.isLoadingPermissionData) {
      this.isLoadingPermissionData = true
      this.loadPermissionData().then(() => {
        this.isLoadingPermissionData = false
      })
    }
    this.loadDataPermission()
    this.loadCardPermission()
  }
  @Watch('currentApp')
  update(val) {
    if (!val) return
    if (!this.isLoadingPermissionData) {
      this.isLoadingPermissionData = true
      this.loadPermissionData().then(() => {
        this.isLoadingPermissionData = false
      })
    }
  }

  async loadAppData() {
    const res = await tasp.getCurrentTenantGrantApps()
    this.appData = res
    console.log(res)
    this.currentApp = this.appData[0].appCode
  }

  async loadPermissionData() {
    this.loading.table = true
    if (this.appData.length === 0) {
      await this.loadAppData()
    }
    const res = await amsp.getAppMenus(this.currentApp, this.roleId)
    this.permissionData = res.menuTree
    this.currentEdition = res.edition
    this.loading.table = false
  }

  async save() {
    this.loading.save = true

    console.log(Object.keys(this.menuTable.editionMap))    
    const temp = Object.keys(this.menuTable.checkMap)
      .filter(item => item !== 'undefined')
      .filter(item => this.menuTable.checkMap[item])
      .map(item => ({
        appCode: this.currentApp,
        menuId: item,
        menuEdition: this.menuTable.editionMap[item]
      }))

    const body = {
      appCode: this.currentApp,
      itemDtoList: temp,
    } as any
    await mrsp.updateMenusInMyRole(body, this.roleId)
    this.loading.save = false
    this.$message.success(this.$t('save_success'))
    await this.loadPermissionData()
  }

  loadDataPermission() {
    this.loading.dataPermission = true
    scheduled(
      [
        from(service({ method: 'GET', url: '/blade-system/menu/grant-tree' })).pipe(
          map(res => res.data.data.dataScope)
        ),
        from(
          service({
            method: 'GET',
            url: `/blade-system/menu/role-tree-keys?roleIds=${this.roleId}`,
          })
        ).pipe(map(res => res.data.data)),
      ],
      asyncScheduler
    )
      .pipe(
        concatAll(),
        reduce((acc, curr) => [acc, curr])
      )
      .subscribe(res => {
        this.dataPermissionTree = {
          treeData: res[0],
          checkedKeys: res[1].dataScope,
          saveBody: { ...res[1] },
        }
        this.loading.dataPermission = false
      })
  }

  saveDataPermission() {
    const userInfo = getUserInfo()
    if (userInfo.role_name !== 'admin') {
      this.$message.error('非管理员用户不允许修改！')
      return
    } 
    this.loading.save = true
    from(
      service({
        method: 'POST',
        url: '/blade-system/role/grant',
        data: {
          roleIds: [this.roleId],
          menuIds: this.dataPermissionTree.saveBody.menu,
          dataScopeIds: this.dataPermissionTree.checkedKeys,
          apiScopeIds: this.dataPermissionTree.saveBody.apiScope,
        },
      })
    ).subscribe(() => {
      this.loading.save = false
      this.$message.success(this.$t('save_success'))
      this.loadDataPermission()
    })
  }

  loadCardPermission() {
    this.loading.cardPermission = true
    concat(
      from(acsp.getCurrentTenantAPPCard()).pipe(
        map(res =>
          res.map(card => ({
            ...card,
            title: card.displayName,
            key: card.id,
          }))
        )
      ),
      from(mrsp.getCardsInMyRole(this.roleId)).pipe(map(res => res.data.idList))
    )
      .pipe(reduce((acc, curr) => [acc, curr] as any))
      .subscribe(res => {
        const app = {}
        for (let treeNode of res[0]) {
          if (!app[treeNode.code]) app[treeNode.code] = { treeData: [], checkedKeys: [] }
          app[treeNode.code].treeData.push({
            title: treeNode.displayName,
            key: treeNode.id,
          })
          if (res[1].includes(treeNode.id)) app[treeNode.code].checkedKeys.push(treeNode.id)
        }
        for (let key in app) {
          this.currentCardApp = key
          break
        }
        this.cardPermissionTree = app
        this.loading.cardPermission = false
      })
  }

  saveCardPermission() {
    this.loading.save = true
    from(
      mrsp.updateCardsInMyRole(
        {
          idList: Object.keys(this.cardPermissionTree)
            .map(name => {
              return this.cardPermissionTree[name].checkedKeys
            })
            .reduce((acc, curr) => acc.concat(curr), []),
        } as any,
        this.roleId
      )
    ).subscribe(() => {
      this.loading.save = false
      this.$message.success(this.$t('save_success'))
      this.loadCardPermission()
    })
  }

  render() {
    const titleNode = text => {
      return (
        <div style="border-left: 4px solid #3a7fbc; color: #3a7fbc; padding-left: 8px; margin-bottom: 16px;">
          {text}
        </div>
      )
    }
    const tabs = () => {
      return (
        <a-tabs v-model={this.currentApp}>
          {this.appData.map(item => (
            <a-tab-pane key={item.appCode} tab={this.$t(item.appCode)}></a-tab-pane>
          ))}
        </a-tabs>
      )
    }
    return (
      <div class="role-permission">
        {titleNode(this.$t('page_role_per'))}
        <a-collapse v-model={this.currentPanel} accordion>
          {this.permissionData.length > 0 ? (
            <a-collapse-panel key="menu" header={this.$t('page_role_fun_per')}>
              {tabs()}
              <MenuTable ref="menuTable" data={this.permissionData} loading={this.loading.table} />
              <div style="position: absolute; left: 0; bottom: 0; right: 0; border: 1px solid #eee; border-left: none; padding: 8px 16px; text-align: right; background: #fff; z-index: 99;">
                <a-button type="primary" onClick={this.save} loading={this.loading.save}>
                  {this.$t('save')}
                </a-button>
              </div>
            </a-collapse-panel>
          ) : (
            <a-collapse-panel key="menu" header={this.$t('page_role_fun_per')}>
              {tabs()}
              <a-empty />
            </a-collapse-panel>
          )}

          <a-collapse-panel key="data" header={this.$t('page_role_data_per')}>
            {this.loading.dataPermission ? (
              <div style="text-align: center">
                <a-spin />
              </div>
            ) : this.dataPermissionTree.treeData.length > 0 ? (
              <a-tree
                v-model={this.dataPermissionTree.checkedKeys}
                checkable
                treeData={this.dataPermissionTree.treeData}
                replaceFields={{ key: 'id' }}
              />
            ) : (
              <a-empty />
            )}
            <div style="position: absolute; left: 0; bottom: 0; right: 0; border: 1px solid #eee; border-left: none; padding: 8px 16px; text-align: right; background: #fff; z-index: 99;">
              <a-button type="primary" onClick={this.saveDataPermission} loading={this.loading.save}>
                {this.$t('save')}
              </a-button>
            </div>
          </a-collapse-panel>

          <a-collapse-panel key="card" header={this.$t('page_role_card_per')}>
            {this.loading.cardPermission ? (
              <div style="text-align: center">
                <a-spin />
              </div>
            ) : (
              <div>
                {Object.keys(this.cardPermissionTree).length > 0 ? (
                  <a-tabs v-model={this.currentCardApp}>
                    {Object.keys(this.cardPermissionTree).map(name => (
                      <a-tab-pane key={name} tab={name}>
                        <a-tree
                          v-model={this.cardPermissionTree[name].checkedKeys}
                          checkable
                          treeData={this.cardPermissionTree[name].treeData}
                        />
                      </a-tab-pane>
                    ))}
                  </a-tabs>
                ) : (
                  <a-empty />
                )}
              </div>
            )}
            <div style="position: absolute; left: 0; bottom: 0; right: 0; border: 1px solid #eee; border-left: none; padding: 8px 16px; text-align: right; background: #fff; z-index: 99;">
              <a-button type="primary" onClick={this.saveCardPermission} loading={this.loading.save}>
                {this.$t('save')}
              </a-button>
            </div>
          </a-collapse-panel>
        </a-collapse>
      </div>
    )
  }
}
